import React from "react";
import { BrainCircuit } from "lucide-react";

const AILoader = () => {
  return (
    <div className="ai-loader-wrapper">
      {/* Background Glow */}
      <div className="ai-bg-glow"></div>

      {/* Main Loader Card */}
      <div className="ai-loader-card">
        {/* Animated Icon */}
        <div className="ai-icon-wrapper">
          <div className="pulse-ring"></div>

          <div className="ai-icon">
            <BrainCircuit size={42} />
          </div>
        </div>

        {/* Heading */}
        <h1 className="ai-title">
          Launching LeadMerge AI Workspace...
        </h1>

        {/* Subtitle */}
        <p className="ai-subtitle">
          AI is analyzing your request and preparing
          intelligent lead insights...
        </p>

        {/* Animated Dots */}
        <div className="typing-loader">
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* AI Steps */}
        {/* <div className="ai-steps">
          <div className="step-item">
            <Sparkles size={16} />
            <span>Understanding Search Intent</span>
          </div>

          <div className="step-item">
            <Sparkles size={16} />
            <span>Generating Smart Filters</span>
          </div>

          <div className="step-item">
            <Sparkles size={16} />
            <span>Fetching Lead Intelligence</span>
          </div>
        </div> */}
      </div>

      {/* CSS */}
      <style jsx>{`
        .ai-loader-wrapper {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #afa9a936;
            backdrop-filter: blur(8px);
            overflow: hidden;
            z-index: 999999;
        }

        .ai-bg-glow {
          position: absolute;
          width: 500px;
          height: 500px;
          background: rgba(79, 3, 65, 0.08);
          border-radius: 50%;
          filter: blur(80px);
          animation: pulseGlow 4s infinite ease-in-out;
        }

        .ai-loader-card {
          position: relative;
          z-index: 2;
          width: 100%;
          max-width: 520px;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(14px);
          border-radius: 32px;
          padding: 50px 40px;
          text-align: center;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
        }

        .ai-icon-wrapper {
          position: relative;
          width: 120px;
          height: 120px;
          margin: auto auto 30px;
        }

        .pulse-ring {
          position: absolute;
          inset: 0;
          border-radius: 50%;
          background: rgba(123, 30, 101, 0.12);
          animation: pulseRing 2.5s infinite;
        }

        .ai-icon {
          position: relative;
          width: 120px;
          height: 120px;
          border-radius: 30px;
          background: linear-gradient(
            135deg,
            #4f0341,
            #7b1e65
          );
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 15px 35px rgba(79, 3, 65, 0.25);
          animation: float 3s ease-in-out infinite;
        }

        .ai-title {
          font-size: 34px;
          font-weight: 800;
          color: #4f0341;
          margin-bottom: 14px;
        }

        .ai-subtitle {
          font-size: 16px;
          color: #6f6f6f;
          line-height: 1.8;
          margin-bottom: 35px;
        }

        .typing-loader {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          margin-bottom: 35px;
        }

        .typing-loader span {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #7b1e65;
          animation: bounce 1.4s infinite ease-in-out both;
        }

        .typing-loader span:nth-child(1) {
          animation-delay: -0.32s;
        }

        .typing-loader span:nth-child(2) {
          animation-delay: -0.16s;
        }

        .ai-steps {
          display: flex;
          flex-direction: column;
          gap: 14px;
          margin-top: 10px;
        }

        .step-item {
          background: #faf7fa;
          border: 1px solid #f1e5ef;
          padding: 14px 18px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          color: #4f0341;
          font-weight: 500;
        }

        @keyframes bounce {
          0%,
          80%,
          100% {
            transform: scale(0);
            opacity: 0.5;
          }

          40% {
            transform: scale(1);
            opacity: 1;
          }
        }

        @keyframes pulseRing {
          0% {
            transform: scale(1);
            opacity: 1;
          }

          100% {
            transform: scale(1.5);
            opacity: 0;
          }
        }

        @keyframes pulseGlow {
          0%,
          100% {
            transform: scale(1);
          }

          50% {
            transform: scale(1.2);
          }
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0px);
          }

          50% {
            transform: translateY(-10px);
          }
        }

        @media (max-width: 768px) {
          .ai-loader-card {
            margin: 20px;
            padding: 40px 25px;
          }

          .ai-title {
            font-size: 28px;
          }
        }
      `}</style>
    </div>
  );
};

export default AILoader;